import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { AnalyticsModule } from '../../core/analytics/analytics.module';
import { LocaleModule } from '../../core/locale/locale.module';
import { RoutingModule } from '../../core/routing/routing.module';
import { DynamicFormModule } from '../../feature/dynamic-form/dynamic-form.module';
import { RecoverComponent } from './recover.component';
import { recoverReducer } from './recover.reducer';
import { SpinnerModule } from 'src/app/feature/spinner/spinner.module';

@NgModule({
	declarations: [RecoverComponent],
	imports: [
		CommonModule,
		StoreModule.forFeature('recover', recoverReducer),
		RoutingModule,
		LocaleModule,
		DynamicFormModule,
		AnalyticsModule,
		SpinnerModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RecoverModule {}
